import { useLayoutEffect, useRef } from "react";
import Slider from "../components/Slider";
import Button from "../components/Shared/Button";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { gsap, Power3 } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { pageAni } from "../Animation";
import SliderTesti from "../components/SliderTesti";

function Home() {
  gsap.registerPlugin(ScrollTrigger);
  const banner = useRef(null);
  const bannerText_1 = useRef(null);
  const bannerText_2 = useRef(null);
  const bannerText_3 = useRef(null);
  const services = useRef(null);
  const section_services = useRef(null);
  let ease = Power3.easeOut;
  const homeTime = gsap.timeline();
  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      homeTime
        .from(banner.current, {
          x: 500,
          skew: 10,
          opacity: 0,
          duration: 0.8,
          delay: 0.2,
        })
        .from(
          [bannerText_1.current, bannerText_2.current, bannerText_3.current],
          {
            x: -200,
            opacity: 0,
            duration: 0.4,
            stagger: 0.1,
          },
          "-=.2"
        );
      gsap.from(services.current, {
        scrollTrigger: {
          trigger: section_services.current,
          start: "top center",
          end: "top center",
        },
        y: 400,
        opacity: 0,
        duration: 0.6,
        ease: ease,
      });
    });
    return () => ctx.revert();
  }, []);
  // variants={pageAni} initial="hidden" animate="show" exit="exit"
  return (
    <motion.main>
      <div className="overflow-hidden pt-22 lg:pt-28">
        <section
          className="section_banner relative  h-[70vh] lg:h-[82vh] mb-1"
          ref={banner}
        >
          <div className="banner_img absolute h-full w-full top-0 right-0 z-10 lg:w-[60%]  ">
            <Slider />
          </div>
          <div className="banner_content absolute w-full lg:w-[40%] bottom-[12%] lg:bottom-1/2  left-0  z-20  bg-white/70 lg:bg-transparent">
            <div className="container py-4 text-center lg:text-left lg:ml-[50px]">
              <h1
                className="text-2xl lg:text-4xl font-semibold mb-1 lg:mb-5"
                ref={bannerText_1}
              >
                A house is made of bricks and beams. A home is made of Hopes and
                dreams
              </h1>
              <p className="leading-6 mb-2 lg:mb-5" ref={bannerText_2}>
                We are an established cabinet business in Melbourne. As a
                dynamic company with broad experience..
              </p>
              <div ref={bannerText_3}>
                <Button>GET FREE CONSULTATION</Button>
              </div>
            </div>
          </div>
          <div className="contact_icons hidden lg:flex absolute bottom-0 lg:left-[60px]">
            <Link
              to="/"
              className="no-underline  text-black hover:text-primeDark mr-4 text-2xl py-2 px-2 "
            >
              <i class="fa-solid fa-phone  "></i>
            </Link>
            <Link
              to="/"
              className="no-underline  text-2xl hover:text-primeDark text-black py-2 px-2"
            >
              <i class="fa-solid fa-envelope "></i>
            </Link>
          </div>
        </section>
        <section className="section_about  py-10 lg:py-20 lg:mt-24  ">
          <div className="container mx-auto">
            <div className="about_content text-center lg:text-left  lg:px-4  mx-auto lg:flex justify-around items-start">
              <h2 className="text-2xl lg:text-4xl lg:leading-[4rem] mb-3 lg:w-1/3 ">
                SR Cabinets - Leading Customer Cabinet Makers in Melbourne
              </h2>
              <div className="about_details lg:w-2/4">
                <p className="leading-7 mb-3">
                  We are an established cabinet business in Melbourne. As a
                  dynamic company with broad experience, we have developed a
                  strong client portfolio, working on domestic as well as
                  commercial projects. As part of the consultation process, we
                  provide a complete design service to ensure every design is
                  planned to perfection. Our services include kitchen cabinets,
                  wardrobes, entertainment units, home office/study spaces and
                  other custom cabinets.
                </p>
                <Button>Touch With Us</Button>
              </div>
            </div>
          </div>
        </section>
        <section
          className="section_services bg-offWhite py-10 lg:py-20 mt-10 lg:mt-20"
          ref={section_services}
        >
          <div className="container lg:px-10 mx-auto" ref={services}>
            <h2 className="text-2xl lg:text-4xl capitalize mb-6">
              Our Services
            </h2>
            <div className="Row flex flex-wrap gap-y-7 md:gap-x-5 ">
              <div className="col pt-5 pb-1 px-6 grow lg:w-[30%] bg-white">
                <div className="flex items-center mb-5">
                  <svg className="service_icons mr-3" viewBox="0 0 100 100">
                    <path d="M26.96 66.61a2.03 2.03 0 0 1-.11 1.16c-.1.24-.25.46-.44.64-.37.38-.88.59-1.41.59-.54 0-1.04-.21-1.41-.59a1.966 1.966 0 0 1-.55-1.8c.02-.13.06-.26.11-.38s.12-.23.19-.34c.07-.11.15-.21.25-.3.74-.75 2.08-.75 2.82 0 .1.09.18.19.25.3.07.11.14.22.19.34.05.12.09.25.11.38zM95 59v30c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2V59c0-1.1.9-2 2-2h16v-4c0-1.1.9-2 2-2s2 .9 2 2v4h4v-8c0-1.1.9-2 2-2s2 .9 2 2v8h4v-4c0-1.1.9-2 2-2s2 .9 2 2v4h50c1.1 0 2 .9 2 2zM9 87h22V61H9v26zm26 0h22V61H35v26zm56-26H61v26h30V61zm-48.15 5.23c-.05-.12-.11-.23-.19-.34-.07-.11-.15-.21-.24-.3a2.022 2.022 0 0 0-2.18-.44c-.13.05-.24.12-.35.19a1.789 1.789 0 0 0-.55.55c-.07.11-.14.22-.19.34-.05.12-.09.25-.11.38a1.998 1.998 0 0 0 .54 1.8c.19.19.41.34.65.44.25.1.5.15.77.15s.52-.05.77-.15c.24-.1.46-.25.65-.44a1.998 1.998 0 0 0 .54-1.8c-.02-.13-.06-.26-.11-.38zM67 69h18c1.1 0 2-.9 2-2s-.9-2-2-2H67c-1.1 0-2 .9-2 2s.9 2 2 2zM26.11 17.34c-.11-.07-.22-.14-.34-.19-.12-.05-.25-.08-.38-.11a2.047 2.047 0 0 0-1.15.11c-.13.05-.24.12-.35.19-.11.07-.21.15-.3.25-.1.09-.18.19-.25.3-.07.11-.14.22-.19.35-.05.12-.08.24-.11.37s-.04.26-.04.39.01.26.04.39.06.26.11.38.12.23.19.34.15.21.25.31a1.998 1.998 0 0 0 1.8.54c.13-.03.25-.06.38-.11.12-.05.23-.12.34-.19.11-.07.21-.15.31-.24.09-.1.17-.2.24-.31.07-.11.14-.22.19-.34.05-.13.08-.25.11-.38s.04-.26.04-.39c0-.53-.21-1.04-.58-1.41-.1-.1-.2-.18-.31-.25zm14.5-.3c-.13.02-.25.06-.38.11-.12.05-.23.12-.34.19-.11.07-.21.15-.3.24-.38.38-.59.89-.59 1.42 0 .53.21 1.04.59 1.41.09.1.19.18.3.25.11.07.22.14.34.19.13.05.25.08.38.11s.26.04.39.04c.53 0 1.04-.21 1.41-.59.38-.37.59-.88.59-1.41 0-.53-.21-1.04-.59-1.42-.46-.46-1.15-.67-1.8-.54zM95 33v8c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2V11c0-1.1.9-2 2-2h52c1.1 0 2 .9 2 2v18.68l8-4.24V11c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2v14.44l10.94 5.79c.65.35 1.06 1.03 1.06 1.77zM9 39h22V13H9v26zm26 0h22V13H35v26zm56-4.8-10.94-5.79A1.987 1.987 0 0 1 79 26.65V13h-6v13.65c0 .74-.41 1.42-1.06 1.77L61 34.2V39h30v-4.8z" />
                  </svg>

                  <h4 className="text-xl font-medium">Kitchen Cabinets</h4>
                </div>
                <p className="text-sm capitalize mb-5">
                  We can design your dream kitchen
                </p>
                <Link
                  to="/services"
                  className=" hover:text-primeDark active:text-prime border-t flex justify-between items-center  text-prime border-gray py-2"
                >
                  <p className=" capitalize">Get your consultaton</p>
                  <i class="fa-solid fa-arrow-right"></i>
                </Link>
              </div>
              <div className="col pt-5 pb-1 px-6 grow lg:w-[30%] bg-white">
                <div className="flex items-center mb-5">
                  <svg className="service_icons mr-3" viewBox="0 0 100 100">
                    <path d="M27 40.015h3v10h-3zM57 40.015h3v10h-3zM87 40.015h3v10h-3z" />
                    <path d="M3.5 83.5v13h11.333v-4.482h70.333V96.5H96.5v-93h-93v80zm8.333 10H6.5v-1.482h5.333V93.5zm81.667 0h-5.333v-1.482H93.5V93.5zm0-4.482h-87V86.5h87v2.518zm-57-5.518v-77h27v77h-27zm57 0h-27v-77h27v77zm-87-77h27v77h-27v-77z" />
                  </svg>

                  <h4 className="text-xl font-medium">Kitchen Cabinets</h4>
                </div>
                <p className="text-sm capitalize mb-5">
                  We can design your dream kitchen
                </p>
                <Link
                  to="/services"
                  className=" hover:text-primeDark active:text-prime border-t flex justify-between items-center  text-prime border-gray py-2"
                >
                  <p className=" capitalize">Get your consultaton</p>
                  <i class="fa-solid fa-arrow-right"></i>
                </Link>
              </div>
              <div className="col pt-5 pb-1 px-6 grow lg:w-[30%] bg-white">
                <div className="flex items-center mb-5">
                  <svg className="service_icons mr-3" viewBox="0 0 100 100">
                    <path d="M27 40.015h3v10h-3zM57 40.015h3v10h-3zM87 40.015h3v10h-3z" />
                    <path d="M3.5 83.5v13h11.333v-4.482h70.333V96.5H96.5v-93h-93v80zm8.333 10H6.5v-1.482h5.333V93.5zm81.667 0h-5.333v-1.482H93.5V93.5zm0-4.482h-87V86.5h87v2.518zm-57-5.518v-77h27v77h-27zm57 0h-27v-77h27v77zm-87-77h27v77h-27v-77z" />
                  </svg>

                  <h4 className="text-xl font-medium">Kitchen Cabinets</h4>
                </div>
                <p className="text-sm capitalize mb-5">
                  We can design your dream kitchen
                </p>
                <Link
                  to="/services"
                  className=" hover:text-primeDark active:text-prime border-t flex justify-between items-center  text-prime border-gray py-2"
                >
                  <p className=" capitalize">Get your consultaton</p>
                  <i class="fa-solid fa-arrow-right"></i>
                </Link>
              </div>
              <div className="col pt-5 pb-1 px-6 grow lg:w-[30%] bg-white">
                <div className="flex items-center mb-5">
                  <svg className="service_icons mr-3" viewBox="0 0 100 100">
                    <path d="M27 40.015h3v10h-3zM57 40.015h3v10h-3zM87 40.015h3v10h-3z" />
                    <path d="M3.5 83.5v13h11.333v-4.482h70.333V96.5H96.5v-93h-93v80zm8.333 10H6.5v-1.482h5.333V93.5zm81.667 0h-5.333v-1.482H93.5V93.5zm0-4.482h-87V86.5h87v2.518zm-57-5.518v-77h27v77h-27zm57 0h-27v-77h27v77zm-87-77h27v77h-27v-77z" />
                  </svg>

                  <h4 className="text-xl font-medium">Kitchen Cabinets</h4>
                </div>
                <p className="text-sm capitalize mb-5">
                  We can design your dream kitchen
                </p>
                <Link
                  to="/services"
                  className=" hover:text-primeDark active:text-prime border-t flex justify-between items-center  text-prime border-gray py-2"
                >
                  <p className=" capitalize">Get your consultaton</p>
                  <i class="fa-solid fa-arrow-right"></i>
                </Link>
              </div>
              <div className="col pt-5 pb-1 px-6 grow lg:w-[30%] bg-white">
                <div className="flex items-center mb-5">
                  <svg className="service_icons mr-3" viewBox="0 0 100 100">
                    <path d="M27 40.015h3v10h-3zM57 40.015h3v10h-3zM87 40.015h3v10h-3z" />
                    <path d="M3.5 83.5v13h11.333v-4.482h70.333V96.5H96.5v-93h-93v80zm8.333 10H6.5v-1.482h5.333V93.5zm81.667 0h-5.333v-1.482H93.5V93.5zm0-4.482h-87V86.5h87v2.518zm-57-5.518v-77h27v77h-27zm57 0h-27v-77h27v77zm-87-77h27v77h-27v-77z" />
                  </svg>

                  <h4 className="text-xl font-medium">Kitchen Cabinets</h4>
                </div>
                <p className="text-sm capitalize mb-5">
                  We can design your dream kitchen
                </p>
                <Link
                  to="/services"
                  className=" hover:text-primeDark active:text-prime border-t flex justify-between items-center  text-prime border-gray py-2"
                >
                  <p className=" capitalize">Get your consultaton</p>
                  <i class="fa-solid fa-arrow-right"></i>
                </Link>
              </div>
              <div className="col pt-5 pb-1 px-6 grow lg:w-[30%] bg-white">
                <div className="flex items-center mb-5">
                  <svg className="service_icons mr-3" viewBox="0 0 100 100">
                    <path d="M27 40.015h3v10h-3zM57 40.015h3v10h-3zM87 40.015h3v10h-3z" />
                    <path d="M3.5 83.5v13h11.333v-4.482h70.333V96.5H96.5v-93h-93v80zm8.333 10H6.5v-1.482h5.333V93.5zm81.667 0h-5.333v-1.482H93.5V93.5zm0-4.482h-87V86.5h87v2.518zm-57-5.518v-77h27v77h-27zm57 0h-27v-77h27v77zm-87-77h27v77h-27v-77z" />
                  </svg>

                  <h4 className="text-xl font-medium">Kitchen Cabinets</h4>
                </div>
                <p className="text-sm capitalize mb-5">
                  We can design your dream kitchen
                </p>
                <Link
                  to="/services"
                  className=" hover:text-primeDark active:text-prime border-t flex justify-between items-center  text-prime border-gray py-2"
                >
                  <p className=" capitalize">Get your consultaton</p>
                  <i class="fa-solid fa-arrow-right"></i>
                </Link>
              </div>
            </div>
          </div>
        </section>
        <section className="section_testi py-10 lg:py-20 mt-10 lg:mt-20">
          <div className="container mx-auto">
            <div className="lg:px-5 lg:flex items-center gap-x-5">
              <div className="py-3  lg:w-1/3 lg:mb-10">
                <p className="text-xs mb-2 capitalize text-gray">tesimonial</p>
                <h2 className="text-2xl lg:text-4xl mb-3 capitalize">
                  What clients says about us
                </h2>
                <p className="leading-7 mb-5 ">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Velit
                  impedit a necessitatibus. Vitae, laborum quibusdam.
                </p>
                <Link
                  to="/contact"
                  className="border border-prime py-2 px-4 lg:py-3 lg:px-6 text-prime hover:bg-prime active:bg-prime hover:text-white ease-in duration-100"
                >
                  Hire
                </Link>
              </div>
              <div className="testi_slider mt-5 lg:w-2/3 lg:mt-0 h-[450px] md:h-[300px] lg:h-[500px]">
                <SliderTesti />
              </div>
            </div>
          </div>
        </section>
      </div>
    </motion.main>
  );
}

export default Home;
